import { render, staticRenderFns } from "./StepForm.vue?vue&type=template&id=79ddf720&scoped=true&"
import script from "./StepForm.vue?vue&type=script&lang=js&"
export * from "./StepForm.vue?vue&type=script&lang=js&"
import style0 from "./StepForm.vue?vue&type=style&index=0&id=79ddf720&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ddf720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ddf720')) {
      api.createRecord('79ddf720', component.options)
    } else {
      api.reload('79ddf720', component.options)
    }
    module.hot.accept("./StepForm.vue?vue&type=template&id=79ddf720&scoped=true&", function () {
      api.rerender('79ddf720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/form/stepForm/StepForm.vue"
export default component.exports